(() => {
  function init(root) {
    root.querySelectorAll('[data-nab-roadmap]').forEach(section => {
      if (section.dataset.routeReady) return;
      section.dataset.routeReady = 'true';
      const wrap = section.querySelector('.nab-route-wrap');
      const svg = wrap.querySelector('.nab-route-curve');
      function draw() {
        const box = wrap.getBoundingClientRect();
        if (!box.width) return;
        const points = [...wrap.querySelectorAll('.nab-stage-dot')].map(dot => {
          const r = dot.getBoundingClientRect();
          return { x: r.left + r.width / 2 - box.left, y: r.top + r.height / 2 - box.top };
        });
        svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
        let d = `M ${points[0].x} ${points[0].y}`;
        points.slice(1).forEach((p, i) => {
          const prev = points[i];
          if (i === 3) {
            const edge = prev.x > box.width / 2 ? box.width - 20 : 20;
            d += ` C ${edge} ${prev.y}, ${edge} ${prev.y + 45}, ${edge} ${prev.y + 80} L ${edge} ${p.y - 80} C ${edge} ${p.y - 45}, ${edge} ${p.y}, ${p.x} ${p.y}`;
          } else {
            const dx = p.x - prev.x;
            d += ` C ${prev.x + dx / 3} ${prev.y + 24}, ${prev.x + 2 * dx / 3} ${p.y - 24}, ${p.x} ${p.y}`;
          }
        });
        svg.querySelectorAll('path').forEach(path => path.setAttribute('d', d));
      }
      draw();
      const observer = new ResizeObserver(draw);
      observer.observe(wrap);
      document.fonts.ready.then(draw);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
